import { render, staticRenderFns } from "./TaskWindow.vue?vue&type=template&id=700b4225&"
import script from "./TaskWindow.vue?vue&type=script&lang=js&"
export * from "./TaskWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports